
import { defineComponent, SetupContext } from "vue";

// Component definition
export default defineComponent({
  name: "CloseButton",
  setup(props, context: SetupContext) {
    // clicked this button
    const closeButtonClick = () => {
      context.emit("close-button-click");
    };
    return {
      closeButtonClick
    };
  }
});
